export const getCurrencySymbol = (currency) => {
    let symbol = '€';
    switch(currency) {
      case 'EUR':
        symbol = '€';
        break;
      case 'USD':
        symbol = '$';
        break;
      case 'GBP':
        symbol = '£';
        break;
      case 'AED':
        symbol = 'د.إ';
        break;      
    }
    return symbol;
  }

if (typeof global !== 'undefined') {
    global.getCurrencySymbol = getCurrencySymbol;
} else if (typeof window !== 'undefined') {
    window.getCurrencySymbol = getCurrencySymbol;
}
